import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box, Button, IconButton, Stack
} from "@mui/material";
import AlertDialog from "../common/Dialog";
import DragHandleIcon from '@mui/icons-material/DragHandle';

// Функция для перестановки элементов
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    console.log(result)
    result.map((item, index)=>{
        item.skating_place=index+1
    })
    return result;
};

const  Skating = ({setComplete, isRoundEnd, Ready, isReady, isDone, places, setPlaces}) => {


    const onDragEnd = (result) => {
        if (!result.destination) return;
        const newItems = reorder(
            places,
            result.source.index,
            result.destination.index
        );
        setPlaces(newItems);
    };


    const [draggingIndex, setDraggingIndex] = useState(null);

    return (
        <>
        <AlertDialog
            name = 'Готово'
            main_message= 'Отправить результаты карточки?'
            message = 'Все разультаты будут отправлены и записаны'
            ok =  'Отправить'
            cancel = 'Подумаю еще'
            okFn={()=>{
                setComplete(true)
            }}
            sx={{
                position: 'fixed',
                zIndex: '10',
                marginLeft: "290px",
                marginTop: "-45px"
            }}
            enabled={isReady || isDone }
        />
    <Button
        onClick={()=>(Ready())}
        variant="outlined"
        style={{
            position: 'fixed',
            zIndex: '10',
            marginLeft: "160px",
            marginTop: "-45px",
            display: isReady ? 'block' : 'none'
        }}
        color="primary">
        начинаем?</Button>
            <Box
                sx={{
                    pt:0,
                    position: "fixed",
                    height: (window.innerHeight - 70) + 'px',
                    overflow: 'hidden',
                    userSelect: "none", // Запрещает выделение текста
                    WebkitUserSelect: "none", // Для Safari
                    MozUserSelect: "none", // Для Firefox
                    MsUserSelect: "none", // Для Internet Explorer

                }}
            >
                {/* Статичная таблица с номерами */}

                <Stack  direction="row">
                <TableContainer component={Paper} sx={{ width: 50, flexShrink: 0, overflowX: 'hidden' }}>
                    <Table
                        size={"small"}
                        // sx={{
                        //     "& .MuiTableCell-root": {
                        //         border: "none",
                        //     },
                        // }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>№</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {places.map((_, index) => (
                                <TableRow
                                    key={`num-${index}`}
                                    sx={{
                                        backgroundColor:
                                            draggingIndex === index ? "rgba(255,165,0,0.5)" : "transparent",
                                        transition: "background-color 0.3s",
                                    }}
                                >
                                    <TableCell sx={{ textAlign: "center"}}>{index + 1}</TableCell>
                                    <TableCell align="right">
                                        <IconButton color="inherit" aria-label="menu" disabled={isReady}>
                                            <DragHandleIcon
                                                sx={{
                                                    visibility: 'hidden',
                                                    width: 0,
                                                    p:0,
                                                    minWidth: 0,
                                                    overflow: 'hidden'
                                                }}
                                            />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Таблица с перетаскиваемыми элементами */}
                <TableContainer component={Paper} sx={{ flexGrow: 1, ml: 1 }}>
                    <Table
                        size={"small"}
                        sx={{
                            tableLayout: "fixed",
                            // "& .MuiTableCell-root": {
                            //     border: "none",
                            // },
                        }}
                    >

                        <DragDropContext
                            onDragStart={(start) => setDraggingIndex(start.source.index)}
                            onDragUpdate={(update) => {
                                // Пока перетаскиваем, обновляем индекс подсветки
                                if (update.destination) {
                                    setDraggingIndex(update.destination.index);
                                } else {
                                    setDraggingIndex(update.source.index);
                                }
                            }}
                            onDragEnd={(result) => {
                                setDraggingIndex(null); // сброс после окончания
                                if (!isReady) onDragEnd(result);
                            }}
                        >
                            {/* таблица с перетаскиваемыми элементами */}
                            <TableContainer component={Paper} sx={{ flexGrow: 1, ml: 0 }}>
                                <Table
                                    size={"small"}
                                    sx={{
                                    tableLayout: "fixed",
                                    // "& .MuiTableCell-root": { border: "none" }
                                }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: "bold" }}>Участники</TableCell>
                                            <TableCell sx={{ width: 60 }} />
                                        </TableRow>
                                    </TableHead>
                                    <Droppable droppableId="table" isDropDisabled={isReady}>
                                        {(provided) => (
                                            <TableBody
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                sx={{
                                                    pointerEvents: !isReady ? "auto" : "none",
                                                    opacity: !isReady ? 1 : 0.6,
                                                }}
                                            >
                                                {places.map((item, index) => (
                                                    <Draggable
                                                        key={item?.leader?.id ?? item?.follower?.id}
                                                        draggableId={item?.leader?.id ?? item?.follower?.id}
                                                        index={index}
                                                        isDragDisabled={isReady}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <TableRow
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                sx={{
                                                                    bgcolor: snapshot.isDragging
                                                                        ? "rgba(255,165,0,0.76)"
                                                                        : !isReady
                                                                            ? ""
                                                                            : "rgb(134,128,128)",
                                                                    transition: "background-color 0.2s",
                                                                    cursor: !isReady ? "grab" : "default",
                                                                }}
                                                            >
                                                                <TableCell sx={{ width: "100%" }}>
                                                                    {
                                                                        item?.number + ". " + item?.leader?.name + " | " + item?.follower?.name
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="right" sx={{ width: "100%" }}>
                                                                    <IconButton color="inherit" aria-label="menu" disabled={isReady}>
                                                                        <DragHandleIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </TableBody>
                                        )}
                                    </Droppable>
                                </Table>
                            </TableContainer>
                        </DragDropContext>
                    </Table>
                </TableContainer>
                </Stack>
            </Box>

        </>
    );
}


export default Skating